enum ConfiguredWebchargeActions {
  DeleteConfiguredWebcharges = "DeleteConfiguredWebcharges",
  CreateConfiguredWebcharges = "CreateConfiguredWebcharges",
  UpdateConfiguredWebcharges = "UpdateConfiguredWebcharges"
}

enum RepeatWebchargeReasons {
  LastWebchargeSuccessful = "ERR_LAST_WEBCHARGE_SUCCESSFUL",
  OverflowMonth= "ERR_WEBCHARGE_OVERFLOW_ALLOWED_CHARGING_MONTH",
  InstantWebcharge = "ERR_INSTANT_WEBCHARGE_CANNOT_BE_REPEATED",
  Default = "DEFAULT_REASON"
}

export {
  ConfiguredWebchargeActions,
  RepeatWebchargeReasons
}
